<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-22 18:17:51
 * @FilePath: 
 * @Description: 挂号结果页
-->
<template>
  <div class="">
    <div class="pay_result_con">
      <i class="iconfont icon-queren c-theme"></i>

      <p class="bold">预约成功</p>
      <p>
        预约号 <i class="bold">{{ bookOrderInfo.Number }}</i>
      </p>
      <p>请于 {{ bookOrderInfo.PeriodTime }} 来店</p>
    </div>
    <div class="book_result_info">
      <div class="f-bt m-b-16">
        <div class="c-f">
          <p class="result_title_con">预约人</p>
          <p>{{ bookOrderInfo.Member }}</p>
        </div>
        <div class="c-f">
          <p class="result_title_con result_title_con_small">手机号</p>
          <p>{{ bookOrderInfo.Mobile }}</p>
        </div>
        <div class="c-f" v-if="isNeedCheckNumber">
          <p class="result_title_con result_title_con_small">预约人数</p>
          <p>{{ bookOrderInfo.BookingNumberOfPeople }}</p>
        </div>
      </div>

      <div class="c-f m-b-16">
        <p class="result_title_con">会员卡</p>
        <p>{{ bookOrderInfo.CardTypeName }}</p>
      </div>
      <div class="c-f m-b-16">
        <p class="result_title_con">预约项目</p>
        <p>{{ bookOrderInfo.GoodsName }}</p>
      </div>
      <div class="c-f m-b-16" v-if="showJIshi">
        <p class="result_title_con">预约诊疗师</p>
        <p>{{ bookOrderInfo.JiShiName }}</p>
      </div>
      <div class="c-f">
        <p class="result_title_con">预约时间</p>
        <p>{{ bookOrderInfo.Creation }}</p>
      </div>
    </div>
    <div class="m-t-56 c-fc-center p-lr-120">
      <van-button
        color="var(--tc)"
        block
        @click="handleToHome"
        style="margin-bottom: 12px"
        >回到首页</van-button
      >
      <van-button color="var(--tc)" plain block @click="handleViewOrder"
        >查看记录</van-button
      >
    </div>
  </div>
</template>

<script>
import { getBookRegisterDetail } from "@/api/bookRegister";
import { handleTimeLocalStorage } from "@/utils";
export default {
  name: "BookRegisterResult",
  props: {},
  data() {
    return {
      showJIshi: false,
      isNeedCheckNumber: false,
      bookOrderInfo: {
        // BookNumber: "125",
        // PersonName: "张三",
        // MemberPhone: "1321212125",
        // CardType: "尊享会员卡",
        // ProjectName: "康复推拿",
        // JishiName: "专家1",
        // PeriodTime: "2023-07-28 09:00-12:00",
        // BookingNumberOfPeople: 1,
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    this.bookId = this.$route.query.BookId;
    this.handleGetBookDetail();
    const bookConfigData = handleTimeLocalStorage.get("bookConfig");
    this.showJIshi = bookConfigData.JsStatusId == 1;
    this.isNeedCheckNumber = bookConfigData.BookingNumberOfPeople == 1;
  },
  methods: {
    handleGetBookDetail() {
      getBookRegisterDetail({
        Id: this.bookId,
        VpnId: this.$store.state.vpnId,
      }).then((res) => {
        res.PeriodTime = res.Taken.split(" ")[0] + " " + res.TimeSpan;

        this.bookOrderInfo = res;
      });
    },
    handleToHome() {
      this.$router.push({
        name: "BookRegisterMenu",
      });
    },
    handleViewOrder() {
      this.$router.push({
        name: "BookHistoryPage",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pay_result_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  margin-bottom: 10px;
  font-size: 26px;
  color: #333;
  .iconfont {
    font-size: 80px;
    margin: 150px 0 20px;
  }
  p {
    margin-bottom: 20px;
    &:last-child {
      font-size: 28px;
    }
  }
}
.book_result_info {
  margin: 32px;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 2px 0px 0px rgba(194, 194, 194, 0.5);
  border-radius: 12px;
  font-size: 24px;
  color: #333;

  .result_title_con {
    width: 120px;
    color: #666;
    font-size: 22px;

    &.result_title_con_small {
      width: unset;
      margin-right: 12px;
    }
  }
}
</style>
